export default {"src":"/_next/static/media/exclamation-circle.fbedf3e6.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};